export const CustomerEmpty = {
  Pr: "あなたの自己紹介を書きましょう",
  DutySummary: "あなたの職歴概要を書きましょう",
  WorkingFrequency: "希望稼働頻度を入力しましょう",
  RequestedFee: "月額報酬目安（週1回稼働の場合）を入力しましょう",
  RequestedCondition: "その他希望条件があれば、入力しましょう",
  Address: "所在地を入力しましょう",
  Requirements: "資格を持っていれば、入力しましょう",
  Language: "扱える語学があれば、入力しましょう",
  AcademicBackgrounds: "最終学歴を書きましょう",
};

export const CustomerEmptyForClient = {
  Pr: "まだ記入がありません",
  DutySummary: "まだ記入がありません",
  WorkingFrequency: "まだ記入がありません",
  RequestedFee: "無し",
  RequestedCondition: "無し",
  Address: "無し",
  Requirements: "無し",
  Language: "無し",
  AcademicBackgrounds: "まだ記入がありません",
  // For Sidebar
  WorkingFrequencyForSidebar: "未入力",
  RequestedFeeForSidebar: "未入力",
  AddressForSidebar: "未入力",
};

export const CustomerAtDeleted = {
  name: "退会済",
};



// WEBPACK FOOTER //
// ./src/config/view_const/customer.ts